var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6857 2.71429C7.82185 2.71429 6.99339 3.05746 6.38255 3.66829C5.77172 4.27912 5.42856 5.10759 5.42856 5.97144V32.0286C5.42856 32.8924 5.77172 33.7209 6.38255 34.3317C6.99339 34.9426 7.82185 35.2857 8.6857 35.2857H29.3143C30.1781 35.2857 31.0066 34.9426 31.6174 34.3317C32.2282 33.7209 32.5714 32.8924 32.5714 32.0286V15.713C32.5714 14.7237 32.1778 13.775 31.4789 13.0747L22.0726 3.66837C21.4618 3.05752 20.6333 2.71433 19.7695 2.71429H8.6857ZM7.46427 5.97144C7.46427 5.64749 7.59296 5.33682 7.82202 5.10776C8.05108 4.8787 8.36176 4.75001 8.6857 4.75001H19V13.5714C19 14.2913 19.286 14.9817 19.795 15.4907C20.304 15.9998 20.9944 16.2857 21.7143 16.2857H30.5357V32.0286C30.5357 32.3525 30.407 32.6632 30.1779 32.8923C29.9489 33.1213 29.6382 33.25 29.3143 33.25H8.6857C8.36176 33.25 8.05108 33.1213 7.82202 32.8923C7.59296 32.6632 7.46427 32.3525 7.46427 32.0286V5.97144ZM29.7757 14.25H21.7143C21.5343 14.25 21.3617 14.1785 21.2344 14.0513C21.1072 13.924 21.0357 13.7514 21.0357 13.5714V5.51001L29.7757 14.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscription);
export default __webpack_public_path__ + "static/media/discription.bf24006caeaa438462fb81c0feb7d01c.svg";
export { ForwardRef as ReactComponent };